import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import { useTransl } from 'shared/lib/i18n';

import RemoteDoormanPopUpContainer from './RemoteDoormanPopUpContainer';

import BuildingPopUpsComponent from './BuildingPopUpsComponent';

import { getBuildingsForFilter } from '../Building/actionCreators';
import { showRenderPropsModal } from '../Modal/actions';
import { deletePopUp, getPopUpList } from './actions';

import { getTodayCount } from '../../utils';

import * as buildingSelectors from '../Building/selectors';
import * as commonSelectors from '../Shared/selectors';
import * as selectors from './selectors';

const listKey = 'BuildingPopUps';

const BuildingPopUpsContainer = (props) => {
  const { t } = useTransl();
  const {
    showRenderPropsModal,
    onGetPopUpList,
    listParams,
    getItems,
    onDeletePopUp,
  } = props;

  const getModalProps = (remoteDoormanPopup) => ({
    title: remoteDoormanPopup?.id
      ? t('buildingSettings.updatePopup')
      : t('buildingSettings.createPopup'),
    maxWidth: 'sm',
    render: (props) => (
      <RemoteDoormanPopUpContainer
        {...props}
        buildingId={remoteDoormanPopup?.building}
        remoteDoormanPopup={remoteDoormanPopup}
        onCloseCallback={() => getItems(listParams)}
      />
    ),
  });

  const showUpdatePopUpModal = (remoteDoormanPopup) => {
    const modalProps = getModalProps(remoteDoormanPopup);
    showRenderPropsModal(modalProps);
  };

  const deletePopUp = async (popUpId) => {
    await onDeletePopUp(popUpId);
    return getItems(listParams);
  };

  const onExport = (paginationParams) => {
    const queryParams = { ...listParams, ...paginationParams };
    return onGetPopUpList(queryParams);
  };

  return (
    <BuildingPopUpsComponent
      {...props}
      showUpdatePopUpModal={showUpdatePopUpModal}
      onExport={onExport}
      deletePopUp={deletePopUp}
    />
  );
};

BuildingPopUpsContainer.propTypes = {
  showRenderPropsModal: PropTypes.func.isRequired,
  onGetPopUpList: PropTypes.func.isRequired,
  getItems: PropTypes.func.isRequired,
  onDeletePopUp: PropTypes.func.isRequired,
  listParams: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = (state) => {
  const listParams = commonSelectors.getListParams(state, listKey);
  const items = selectors.getPopUpList(state);
  const buildings = buildingSelectors.getBuildings(state);
  return {
    listKey,
    listParams,
    items,
    buildings,
  };
};

const mapDispatchToProps = (dispatch) => ({
  onLoad: (params) => {
    getBuildingsForFilter(dispatch, params);
  },
  getItems: (queryParams) => {
    getPopUpList(dispatch, queryParams);
    getTodayCount(getPopUpList, dispatch, queryParams);
  },
  onGetPopUpList: (queryParams) => getPopUpList(dispatch, queryParams, true),
  onDeletePopUp: (popUpId) => deletePopUp(dispatch, popUpId),
  showRenderPropsModal: (modalProps) =>
    showRenderPropsModal(dispatch, modalProps),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(BuildingPopUpsContainer);
